import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { SalesPage } from "./pages/SalesPage";
export function App() {
  return <>
      <MetaPixel data-id="element-0" data-mp="35c28kv02tw3o" />
      <SalesPage data-id="element-1" data-mp="35eoc8jjujrgm" />
    </>;
}